import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'
import { Caution } from 'components/Typography'
import { Info } from 'components/Typography'

type Props = {
  content: string
  description: string
  subDescription?: string
  url?: string
  title: string
  type?: 'caution' | 'info'
}

const SettingsWarningCard: FC<Props> = (props) => {
  const { content, description, subDescription, url, title, type = 'caution' } = props

  return (
    <div className={styles.warning}>
      <div className={styles.warning__title}>
        <img src={'/icon/black/caution.svg'} alt={'注意'} />
        <Spacer size={5} axis={'horizontal'} />
        {title}
      </div>
      <Spacer size={5} />
      <p className={styles.warning__description}>{description}</p>
      {subDescription && url && (
        <>
          <Spacer size={4} />
          <p className={styles.warning__description_sub}>
            {subDescription}
            <a className={styles.warning__link} href={url} rel={'noreferrer nofollow'} target={'_blank'}>
              こちら
            </a>
          </p>
        </>
      )}
      <Spacer size={8} />
      {type === 'caution' && <Caution caution={content} />}
      {type === 'info' && <Info info={content} />}
    </div>
  )
}

export default SettingsWarningCard
